module.exports = __webpack_public_path__ + "static/media/5ed79938a419334baf732d41.896d81e8.png";